import React, { useState, useEffect, useMemo } from "react";
import { Tabs } from "antd";
import {
  DollarOutlined,
  CreditCardOutlined,
  BankOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import PaymentAllocationHistory from "../Shared/Allocation/PaymentAllocationHistory";
import CreditAllocationHistory from "../Shared/Allocation/CreditAllocationHistory";
import CashAllocationHistory from "../Shared/Allocation/CashAllocationHistory";
import OverpaymentAllocationHistory from "../Shared/Allocation/OverpaymentAllocationHistory";
import { useLocation } from "react-router-dom";

const AllocationHistory = ({ selectedBrand = null }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    // Prefer location state, then localStorage
    if (location.state && location.state.allocationHistoryTab) {
      setActiveTab(location.state.allocationHistoryTab);
    } else if (localStorage.getItem("allocation_history_active_tab")) {
      setActiveTab(localStorage.getItem("allocation_history_active_tab"));
      localStorage.removeItem("allocation_history_active_tab");
    }
  }, [location]);

  const onTabChange = (key) => {
    setActiveTab(key);
    // Save to localStorage for persistence
    localStorage.setItem("allocation_history_active_tab", key);
  };

  // Define tab items with lazy rendering - only render active tab content
  const tabItems = useMemo(() => [
    {
      key: "1",
      label: (
        <span>
          <DollarOutlined className="me-2" />
          Payment Allocations
        </span>
      ),
      children: activeTab === "1" ? <PaymentAllocationHistory selectedBrand={selectedBrand} /> : null,
    },
    {
      key: "2",
      label: (
        <span>
          <CreditCardOutlined className="me-2" />
          Credit Allocations
        </span>
      ),
      children: activeTab === "2" ? <CreditAllocationHistory selectedBrand={selectedBrand} /> : null,
    },
    {
      key: "3",
      label: (
        <span>
          <BankOutlined className="me-2" />
          Cash Allocations
        </span>
      ),
      children: activeTab === "3" ? <CashAllocationHistory selectedBrand={selectedBrand} /> : null,
    },
    {
      key: "4",
      label: (
        <span>
          <WalletOutlined className="me-2" />
          Overpayment Allocations
        </span>
      ),
      children: activeTab === "4" ? <OverpaymentAllocationHistory selectedBrand={selectedBrand} /> : null,
    },
  ], [activeTab, selectedBrand]);

  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      size="small"
      items={tabItems}
      destroyInactiveTabPane={true}
    />
  );
};

export default AllocationHistory;
